module.exports = __webpack_public_path__ + "img/install_01.91e70e95.jpg";